var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3033 3333",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1511 0c566 358 1076 528 1515 488 77 1549-495 2464-1509 2845C538 2976-41 2100 2 464c515 27 1020-84 1509-464zM916 1811c-32-27-36-76-8-108 27-32 76-36 108-8l312 268 683-751c28-31 77-33 108-5s33 77 5 108l-733 806c-28 30-75 34-106 7l-368-316zm595-1620c501 317 953 467 1341 432 68 1371-439 2181-1336 2519C650 2826 137 2051 175 603c456 24 903-75 1336-411z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIcon);
export default __webpack_public_path__ + "static/media/shield-icon.637d563c8aefc63645c09a476f26b1d1.svg";
export { ForwardRef as ReactComponent };